import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import { useChatContext } from "stream-chat-react";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const APP_BAR_HEIGHT = 64;

const ChatSelectorPage = () => {
  const [genres, setGenres] = useState([
    { id: "general", name: "雑談" },
    { id: "growth", name: "成長" },
    { id: "question", name: "質問" },
  ]);
  const [selectedGenre, setSelectedGenre] = useState("general");
  const [channels, setChannels] = useState([]);
  const { client } = useChatContext();

  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [newChannelName, setNewChannelName] = useState("");

  useEffect(() => {
    const fetchChannels = async () => {
      const filters = {
        type: "messaging",
        customType: selectedGenre,
        members: { $in: [client.userID] },
      };
      const sort = [{ last_message_at: -1 }];
      const response = await client.queryChannels(filters, sort, {
        watch: true,
        state: true,
      });
      setChannels(response);
    };

    if (client) fetchChannels();
  }, [client, selectedGenre]);

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#f5f5f5",
          overflow: "hidden", // 親Boxにはスクロール不要
          zIndex: 0,
        }}
      >
        <Box
          sx={{
            maxWidth: 1200,
            margin: "0 auto",
            backgroundColor: "#ffffff",
            borderRadius: 2,
            boxShadow: 3,
            mt: `${APP_BAR_HEIGHT + 16}px`,
            height: `calc(100vh - ${APP_BAR_HEIGHT + 32}px)`, // ← ここで高さ制限
            display: "flex",
            flexDirection: "column",
            p: 1,
            //   backgroundColor:"f9f9f9"
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{
              flexGrow: 1,
              // overflow: "hidden",
              height: "100%",
            }}
          >
            {/* Left - Genre */}
            <Grid item xs={3}>
              {" "}
              {/* ← height 追加 */}
              <Paper
                elevation={1}
                sx={{
                  height: "calc(100% - 4px)",
                  width: "calc(100% - 4px)",
                  overflowY: "auto",
                  p: 2,
                  borderRadius: 2,
                  boxShadow: 4,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  ジャンル
                </Typography>
                <List>
                  {genres.map((genre) => (
                    <ListItemButton
                      key={genre.id}
                      selected={selectedGenre === genre.id}
                      onClick={() => setSelectedGenre(genre.id)}
                    >
                      <ListItemText primary={genre.name} />
                    </ListItemButton>
                  ))}
                </List>
              </Paper>
            </Grid>

            {/* Right - Channels */}
            <Grid item xs={9}>
              {" "}
              {/* ← height 追加 */}
              <Paper
                elevation={1}
                sx={{
                  height: "calc(100% - 4px)",
                  width: "calc(100% - 4px)",
                  overflowY: "auto",
                  p: 2,
                  borderRadius: 2,
                  boxShadow: 4,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Typography variant="h6">チャット一覧</Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => setOpenCreateDialog(true)}
                  >
                    チャット作成
                  </Button>
                </Box>

                <List>
                  {channels.map((channel) => (
                    <ListItemButton
                      key={channel.id}
                      onClick={() => {
                        console.log("Open channel:", channel.id);
                      }}
                    >
                      <ListItemText
                        primary={channel.data.name || "無名チャンネル"}
                        secondary={channel.data.description}
                      />
                    </ListItemButton>
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Dialog
        open={openCreateDialog}
        onClose={() => setOpenCreateDialog(false)}
        fullWidth
      >
        <DialogTitle>チャット作成</DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label="チャット名"
            value={newChannelName}
            onChange={(e) => setNewChannelName(e.target.value)}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenCreateDialog(false)}>キャンセル</Button>
          <Button
            variant="contained"
            onClick={async () => {
              try {
                const newChannel = client.channel("messaging", {
                  name: newChannelName,
                  customType: selectedGenre,
                  members: [client.userID],
                });
                await newChannel.create();
                setNewChannelName("");
                setOpenCreateDialog(false);
                const updated = await client.queryChannels(
                  {
                    type: "messaging",
                    customType: selectedGenre,
                    members: { $in: [client.userID] },
                  },
                  [{ last_message_at: -1 }],
                  { watch: true, state: true }
                );
                setChannels(updated);
              } catch (err) {
                console.error("チャット作成失敗", err);
              }
            }}
          >
            作成
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ChatSelectorPage;
